export default {
    getCenter: (state) => {
        return state.center
    },
}
